import React, { useState, useEffect, useRef } from "react";
import Select from 'react-select';
import axios from "axios";
import { getsessionuser } from "../Utils/sessions";
import { Alert, Button, Checkbox, Container, FormControlLabel, FormGroup, IconButton, Snackbar, TextField, TextareaAutosize } from "@mui/material";
import { AddCircle, Check, Clear, Delete, RadioButtonChecked, RadioButtonUnchecked, Save } from "@mui/icons-material";
import { primarycolor } from "../Utils/colors";
import Loadingspinner from "../Components/loading";
import { types } from "../Utils/arrays";
import { Addpropertyurl, Posthouseimagesurl, node_base_url } from "../Utils/urls";
import { base64tofile, checkimageextension, getBase64, navigatetopath } from "../Utils/functions";
import { FaCloudUploadAlt } from "react-icons/fa";


const Addproperty = ({ oncancelfund }) => {


    useEffect(() => {
        getlocation();
    }, [])

    //get current user location
    const getlocation = () => {
        navigator.geolocation.getCurrentPosition(
            function (position) {
                setlatitude(position.coords.latitude)
                setlongitude(position.coords.longitude)
            },
            function (error) {
                alert(error.message + ". PLease allow location to continue");
            }
        );

    }

    const scrollref = useRef();

    const user = getsessionuser()
    const [error, setError] = useState(null);
    const [success, setsuccess] = useState('');
    const [loading, setLoading] = useState(false);
    const [nothing, setnothing] = useState(false);
    const [showothertypes, setshowothertypes] = useState(false);

    //hostel states
    const [housename, sethousename] = useState('');
    const [description, setdescription] = useState('');
    const [phone, setphone] = useState(user?.phone);
    const [category, setcategory] = useState('');
    const [roomtype, setroomtype] = useState('');
    const [totalrooms, settotalrooms] = useState('');
    const [availablerooms, setavailablerooms] = useState('');
    const [location, setlocation] = useState('');
    const [landmark, setlandmark] = useState('');
    const [price, setprice] = useState('');
    const [subtotal, setsubtotal] = useState('');
    const [facilities, setfacilities] = useState([]);
    const [images, setimages] = useState([]);

    const [longitude, setlongitude] = useState('');
    const [latitude, setlatitude] = useState('');

    //facilities
    const [dustbin, setdustbin] = useState(false);
    const [kitchensink, setkitchensink] = useState(false);
    const [bathroom, setbathroom] = useState(false);
    const [balcony, setbalcony] = useState(false);
    const [ceiling, setceiling] = useState(false);
    const [toilet, settoilet] = useState(false);
    const [hotshower, sethotshower] = useState(false);
    const [router, setrouter] = useState(false);
    const [gate, setgate] = useState(false);
    const [chair, setchair] = useState(false);
    const [tiles, settiles] = useState(false);
    const [matress, setmatress] = useState(false);
    const [bed, setbed] = useState(false);

    const [maindata, setmaindata] = useState('');
    const [othertypes, setothertypes] = useState([]);

    const url = "https://eazistey.co.ke/API_WEB_HOOKS/images/image2.png";

    const date = new Date()

    const submit = () => {
        setLoading(true)
        if (!housename | !location) {
            setLoading(false)
            setError("Fill all fields");
        } else {
            setError(null)
            axios.post(Addpropertyurl, {
                maindata: maindata,
                othertypes: othertypes
            }).then(response => {
                if (!response.data.message) {
                    if (images.length > 0) {
                        uploadimages(response.data.id)//upload images if any
                    } else {
                        setLoading(false)
                        setsuccess(response.data.success)
                        setTimeout(() => {
                            oncancelfund()
                        }, 3000);
                    }
                } else {
                    setLoading(false)
                    setError(response.data.message)
                }
                // 
            }).catch(error => {
                console.log(error)
                setLoading(false)
                setError("Sorry an error occurred,try again latrer");
            });
        }

    }

    //add another option
    const addothertype = () => {
        //if there's no other types added
        if (othertypes.length < 1) {

            const myObj = [{
                dustbin: dustbin ? "dustbin" : null,
                kitchensink: kitchensink ? "kitchensink" : null,
                bathroom: bathroom ? "bathroom" : null,
                balcony: balcony ? "balcony" : null,
                ceiling: ceiling ? "ceiling" : null,
                toilet: toilet ? "toilet" : null,
                bed: bed ? "bed" : null,
                hotshower: hotshower ? "hotshower" : null,
                router: router ? "router" : null,
                gate: gate ? "gate" : null,
                chair: chair ? "chair" : null,
                tiles: tiles ? "tiles" : null,
                matress: matress ? "matress" : null,
            }];

            const mainobj = {
                username: user?.username,
                email: user?.email,
                phone: phone,
                campus: user?.campus,
                status: "Unapproved",
                plan: "FREE PLAN",
                blockedstatus: "OPEN",
                category: category,
                type: roomtype,
                housename: housename,
                description: description,
                totalrooms: totalrooms,
                availablerooms: availablerooms,
                location: location,
                landmark: landmark,
                price: price,
                subtotal: subtotal,
                facilities: JSON.stringify(myObj),
                longitude: longitude,
                latitude: latitude,
                profilepic_url: url,
                date: date.getTime(),
                pic1_url: url,
                pic2_url: url,
                pic3_url: url,
                pic4_url: url,
                pic5_url: url,
                pic6_url: url
            }
            setmaindata(mainobj)
        }
        setshowothertypes(true)
        resetform()
        navigatetopath("top")
    }

    //upload images if any
    const uploadimages = (id) => {
        setError()
        setLoading(true)
        const formData = new FormData();
        images.map((element, key) => {//append each file in the images array
            const updatedfile = base64tofile(element.picturestring, `pic${key + 1}_url.png`)
            formData.append('images', updatedfile);
        })
        formData.append('id', id);
        formData.append('url', node_base_url);
        const config = { headers: { 'content-type': 'multipart/form-data' } }
        axios.post(Posthouseimagesurl, formData, config).then(response => {
            setLoading(false)
            if (!response.data.error) {
                setsuccess(response.data.success)
                setTimeout(() => {
                    oncancelfund()
                }, 3000);
            } else {
                setError(response.data.message)
            }
            // 
        }).catch(error => {
            console.log(error)
            setLoading(false)
            setError("Sorry an error occurred,try again later");
        });
    }



    //push image selected into the array
    const pushimage = (image) => {
        if (image) {
            if (!checkimageextension(image.name)) {
                setError("Unsupported Format")
                setTimeout(() => { setError() }, 2000);
            } else {
                getBase64(image, (result) => {
                    const object = {
                        value: image,
                        picturestring: result
                    }
                    images?.push(object)
                    setnothing(!nothing)
                })
            }
        }
    }

    //check data completion
    const checkcompletion = () => {
        if (category, housename, location, landmark) {
            return false;
        }
        return true;
    }

    //push type
    const pushtype = (action) => {
        const myObj = [{
            dustbin: dustbin ? "dustbin" : null,
            kitchensink: kitchensink ? "kitchensink" : null,
            bathroom: bathroom ? "bathroom" : null,
            balcony: balcony ? "balcony" : null,
            ceiling: ceiling ? "ceiling" : null,
            toilet: toilet ? "toilet" : null,
            bed: bed ? "bed" : null,
            hotshower: hotshower ? "hotshower" : null,
            router: router ? "router" : null,
            gate: gate ? "gate" : null,
            chair: chair ? "chair" : null,
            tiles: tiles ? "tiles" : null,
            matress: matress ? "matress" : null,
        }];

        const mainobj = {
            type: roomtype,
            totalrooms: totalrooms,
            availablerooms: availablerooms,
            price: price,
            subtotal: subtotal,
            facilities: JSON.stringify(myObj)
        }

        othertypes.push(mainobj)
        resetform()

        if (action) {
            setshowothertypes(false)
            navigatetopath("bottom")
        }
    }

    const resetform = () => {
        setroomtype('')
        settotalrooms('')
        setavailablerooms('')
        setprice('')
        setsubtotal('')
        setdustbin(false)
        setkitchensink(false)
        setbalcony(false)
        setbathroom(false)
        setceiling(false)
        settoilet(false)
        setbed(false)
        sethotshower(false)
        setrouter(false)
        setgate(false)
        setchair(false)
        settiles(false)
        setmatress(false)
        setnothing(!nothing)
    }

    const removetype = (key) => {
        othertypes.splice(key, 1)
        setnothing(!nothing)
    }



    const textinputstyles = {
        maxHeight: 20,
        marginRight: 5,
        width: "100%",
        marginBottom: 5,
        fontSize: 10
    }




    return (
        <Container sx={{
            backgroundColor: "white",
            marginTop: 5,
            padding: 5,
            borderRadius: 2,
            position: "relative"
        }} maxWidth="sm">
            {loading && <Loadingspinner />}
            <Snackbar open={error?.length > 0 && true} autoHideDuration={3000} onClose={() => setError()}>
                <Alert severity="error">{error}</Alert>
            </Snackbar>
            <Snackbar open={success?.length > 0 && true} autoHideDuration={3000} onClose={() => setsuccess()}>
                <Alert severity="success">{success}</Alert>
            </Snackbar>
            <div style={{ position: "absolute", right: 3, top: -3 }}>
                <IconButton onClick={() => oncancelfund()}><Clear /></IconButton>
            </div>
            <div className="overflowdivwithoutscroll" ref={scrollref}>
                <div id="top" />
                <div className="right2">
                    {!showothertypes &&
                        <div>
                            Select Category
                            <div style={{ width: "50%", display: "flex", justifyContent: "space-between" }}>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    Students:
                                    <IconButton onClick={() => setcategory("students")}>
                                        {category === "students" ? <RadioButtonChecked /> : <RadioButtonUnchecked />}
                                    </IconButton>
                                </div>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    Non-Students:
                                    <IconButton onClick={() => setcategory("non-students")}>
                                        {category === "non-students" ? <RadioButtonChecked /> : <RadioButtonUnchecked />}
                                    </IconButton>
                                </div>
                            </div><br />
                            House name<br />
                            <TextField id="outlined-basic" sx={textinputstyles} placeholder="House name" variant="outlined" size="small" value={housename} onChange={(e) => sethousename(e.target.value)} /><br />
                            Description<br />
                            <TextField
                                sx={{ width: "100%" }}
                                multiline
                                name="description"
                                onChange={(e) => {
                                    const inputContent = e.target.value;
                                    const words = inputContent.trim().split(/\s+/);
                                    if (words.length <= 100) {
                                        setdescription(inputContent);
                                    }
                                }}
                                value={description}
                                minRows={3}
                                maxRows={5}
                                error={description.trim().split(/\s+/).length > 100}
                                helperText={
                                    description.trim().split(/\s+/).length >= 90 &&
                                        description.trim().split(/\s+/).length < 100
                                        ? "Approaching word limit"
                                        : description.trim().split(/\s+/).length >= 100
                                            ? "Maximum number of words reached"
                                            : ""
                                }
                            /><br />
                            Caretaker phone<br />
                            <TextField id="outlined-basic" sx={textinputstyles} placeholder="phone" variant="outlined" autoComplete="tel" size="small" value={phone} onChange={(e) => setphone(e.target.value)} /><br />
                            Location:<br />
                            <TextField id="outlined-basic" sx={textinputstyles} placeholder="location" type={"text"} variant="outlined" size="small" value={location} onChange={(e) => setlocation(e.target.value)} /><br />
                            Landmarks:<br />
                            <TextField id="outlined-basic" sx={textinputstyles} placeholder="landmark" type={"text"} variant="outlined" size="small" value={landmark} onChange={(e) => setlandmark(e.target.value)} /><br />
                        </div>
                    }
                    Select Room type
                    <div style={{ width: "100%" }}>
                        <Select menuPlacement="top" options={types} onChange={e => setroomtype(e.value)}  ></Select>
                    </div><br />
                    Total rooms:<br />
                    <TextField id="outlined-basic" sx={textinputstyles} placeholder="total rooms" type={"number"} variant="outlined" size="small" value={totalrooms} onChange={(e) => settotalrooms(e.target.value)} /><br />
                    Available rooms:<br />
                    <TextField id="outlined-basic" sx={textinputstyles} placeholder="available" type={"number"} variant="outlined" size="small" value={availablerooms} onChange={(e) => setavailablerooms(e.target.value)} /><br />
                    Rent per sem:<br />
                    <TextField id="outlined-basic" sx={textinputstyles} placeholder="rent per sem" type={"number"} variant="outlined" size="small" value={price} onChange={(e) => setprice(e.target.value)} /><br />
                    Rent per month:<br />
                    <TextField id="outlined-basic" sx={textinputstyles} placeholder="rent per month" type={"number"} variant="outlined" size="small" value={subtotal} onChange={(e) => setsubtotal(e.target.value)} /><br />
                </div>
                <div><b style={{ color: primarycolor }}>Facilities</b></div>
                <div>
                    <div style={{ display: "flex", justifyContent: "space-between", width: "60%" }}>
                        <div>
                            <FormControlLabel control={<Checkbox onClick={() => setdustbin(!dustbin)} checked={dustbin} />} label="Dustbin" /><br />
                            <FormControlLabel control={<Checkbox onClick={() => setkitchensink(!kitchensink)} checked={kitchensink} />} label="Kitchensink" /><br />
                            <FormControlLabel control={<Checkbox onClick={() => setbathroom(!bathroom)} checked={bathroom} />} label="Bathroom" /><br />
                            <FormControlLabel control={<Checkbox onClick={() => setbalcony(!balcony)} checked={balcony} />} label="Balcony" /><br />
                            <FormControlLabel control={<Checkbox onClick={() => setceiling(!ceiling)} checked={ceiling} />} label="Ceiling" /><br />
                            <FormControlLabel control={<Checkbox onClick={() => settoilet(!toilet)} checked={toilet} />} label="Toilet" /><br />
                            <FormControlLabel control={<Checkbox onClick={() => sethotshower(!hotshower)} checked={hotshower} />} label="Hotshower" /><br />
                        </div>
                        <div>
                            <FormControlLabel control={<Checkbox onClick={() => setrouter(!router)} checked={router} />} label="Router" /><br />
                            <FormControlLabel control={<Checkbox onClick={() => setgate(!gate)} checked={gate} />} label="Gate" /><br />
                            <FormControlLabel control={<Checkbox onClick={() => setchair(!chair)} checked={chair} />} label="Chair" /><br />
                            <FormControlLabel control={<Checkbox onClick={() => settiles(!tiles)} checked={tiles} />} label="Tiles" /><br />
                            <FormControlLabel control={<Checkbox onClick={() => setmatress(!matress)} checked={matress} />} label="Matress" /><br />
                            <FormControlLabel control={<Checkbox onClick={() => setbed(!bed)} checked={bed} />} label="Bed" /><br />
                        </div>
                    </div>
                </div>
                {!showothertypes && <div><b style={{ color: primarycolor }}>Images</b></div>}
                {!showothertypes &&
                    <div className="wrapaddedimages">
                        {images?.map((val, key) => {
                            return (
                                <img src={val.picturestring} key={key} />
                            )
                        })
                        }
                    </div>}
                {!showothertypes &&
                    <div>
                        <input
                            id="houseimage"
                            type="file"
                            name="houseimage"
                            onInput={(e) => pushimage(e.target.files[0])}
                            style={{ display: "none" }}
                        />
                        <label for={"houseimage"}  >
                            <div style={{
                                width: "100%"
                            }}>
                                <text style={{ fontSize: 15 }}>Upload house image </text>
                                <div className="uploaddiv">
                                    <FaCloudUploadAlt size={70} color="silver" /><br />
                                    <text style={{ color: "silver" }}>Drag the file here, or Click to upload </text>
                                </div>
                            </div>
                        </label><br />
                    </div>}
                {othertypes.length > 0 &&
                    <div>
                        Room Types added:
                        <div className="wrapothertypes">
                            {othertypes.map((val, key) => {

                                return (
                                    <div className="othertypediv" key={key}>
                                        <div>
                                            <IconButton onClick={() => removetype(key)}>
                                                <Clear sx={{ color: "red" }} />
                                            </IconButton>
                                        </div>
                                        <b>Type: </b>{val.type}<br />
                                        <b>Price:</b>Ksh {val.price}
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                }
                <br /><br />
                <div className="bottom2" id="bottom">
                    {error && <div className="error">{error}</div>}
                    <div style={{ display: "flex" }}>
                        <Button disabled={checkcompletion()} onClick={() => showothertypes ? pushtype() : addothertype()} variant="outlined">
                            Add other type
                        </Button>&nbsp;&nbsp;
                        {showothertypes &&
                            <Button variant="contained" startIcon={<Check />} onClick={() => pushtype(true)}>
                                Done
                            </Button>}
                        {!showothertypes &&
                            <Button disabled={checkcompletion()} variant="contained" startIcon={<Save />} onClick={() => submit()}>
                                Submit
                            </Button>}
                    </div><br />
                </div>

            </div>
        </Container>
    );
}

export default Addproperty;